export const environment = {
  baseUrl: 'https://veterans-cms.demo.ukrohost.com',
  production: true,
  api: {
    url: 'https://veterans-api.demo.ukrohost.com',
    routes: {
      api: 'api',
      auth: 'auth',
      admin: 'admin',
      front: 'front',
    },
  },
  front: {
    url: 'https://veterans-portal.demo.ukrohost.com',
  },
}
